function SiteFooterController($scope, $element, $window) {
    $scope.menuItems = [];
    $scope.year = new Date().getFullYear();

    this.$postLink = function() {
        var navItems = [];
        // Get the nal list
        var $ul = $element.find('ng-transclude ul');
        // Hide the list
        $ul.css('display', 'none');
        // Loop through the items
        $('li', $ul).each(function() {
            // Get the A element
            var $a = $('a', $(this)).first();
            if ($a.length <= 0) return;
            // Add to collection
            navItems.push({
                className: $(this)[0].className,
                label: $a[0].text,
                href: $a[0].href
            });
        });
        navItems.push({
            className: 'nav-privacy',
            label: 'Privacy Statement',
            href: '/privacy-statement'
        });
        $scope.menuItems = navItems;
    };
}

angular.module('app')
    .component('siteFooter', {
        transclude: true,
        controller: ['$scope', '$element', '$window', SiteFooterController],
        templateUrl: '/assets/built/app/components/siteFooter/siteFooter.html'
    });
